<template>
  <div id="productViewer" class="centerx">
    <vs-popup
      :title="'Ürün İncele #' + value.productName"
      @close="cancel"
      :active.sync="visible"
    >
      <div style="height: 400px; overflow-y: auto">
        <vs-tabs :color="colorx">
          <vs-tab
            label="Ürün Özellikleri"
            icon="pets"
            @click="colorx = '#16e94e'"
          >
            <span>Ürün Resimleri</span>
            <div>
              <img
                style="width=32px; height:32px;"
                class="mr-2"
                :src="src"
                v-for="(src, index) in imgs"
                :key="index"
                @click="() => showImg(index)"
              />
            </div>
            <vue-easy-lightbox
              :visible="visibleImage"
              :imgs="imgs"
              :index="index"
              @hide="handleHide"
              moveDisabled
            ></vue-easy-lightbox>
          </vs-tab>
          <vs-tab
            label="Bank"
            icon="account_balance"
            @click="colorx = '#FFA500'"
          ></vs-tab>
          <vs-tab
            label="Dashboard"
            icon="dashboard"
            @click="colorx = '#8111e8'"
          ></vs-tab>
          <vs-tab
            label="Profile"
            icon="account_circle"
            @click="colorx = '#48d1e0'"
          ></vs-tab>
        </vs-tabs>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import VueEasyLightbox from "vue-easy-lightbox";
export default {
  components: {
    vSelect,
    VueEasyLightbox,
  },
  props: {
    isViewerActive: {
      type: Boolean,
      required: true,
    },
    value: "",
  },
  data() {
    return {
      colorx: "#8B0000",
      visibleImage: false,
      index: 0, // default: 0
      imgs: [
        "https://i.pinimg.com/originals/d5/eb/a5/d5eba595ec93552e08be0e19844824ad.jpg",
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQO2qesYiMbZ8KxKB55LMygZy0E0qhRvOdolQ&usqp=CAU",
        "https://www.dunyaatlasi.com/wp-content/uploads/2018/09/resim-tablo-nasil-okunur.jpg",
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQO2qesYiMbZ8KxKB55LMygZy0E0qhRvOdolQ&usqp=CAU",
      ],
    };
  },
  computed: {
    visible: {
      get() {
        return this.isViewerActive;
      },
      set() {},
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.transferDetails != "" &&
        this.selectedSube != ""
      );
    },
  },

  methods: {
    showImg(index) {
      this.index = index;
      this.visibleImage = true;
    },
    handleHide() {
      this.visibleImage = false;
    },
    cancel() {
      this.$emit("closeViewer");
    },
    submit() {
      //sumb
    },
  },
};
</script>

<style lang="scss" scoped>
#productViewer {
  .con-vs-dialog .vs-dialog {
    width: 600px !important;
  }
}
</style>